import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { PaginationConfig } from '../../../shared/configs/paginator.config';
import { IPagination } from '../../../shared/interfaces/paginator.interface';

@Injectable({
  providedIn: 'root',
})
export class AgGridPaginationUtilService {
  private paginationChangeSource = new Subject<{
    pagination :IPagination;
    selectedRows :any[];
    isSelectAllRows :boolean;
  }>();

  private selectAllChangeSource = new Subject<{
    pagination :IPagination;
    selectedRows :any[];
    isSelectAllRows :boolean;
  }>();

  paginationChanged$ = this.paginationChangeSource.asObservable();

  selectAllChanged$ = this.selectAllChangeSource.asObservable();

  notifyPaginationChange({
    pagination,
    selectedRows,
    isSelectAllRows,
  } :{
    pagination :IPagination;
    selectedRows :any[];
    isSelectAllRows :boolean;
  }) :void {
    this.paginationChangeSource.next({
      pagination,
      selectedRows,
      isSelectAllRows,
    });
  }

  notifySelectAllChange({
    pagination,
    selectedRows,
    isSelectAllRows,
  } :{
    pagination :IPagination;
    selectedRows :any[];
    isSelectAllRows :boolean;
  }) :void {
    this.selectAllChangeSource.next({
      pagination,
      selectedRows,
      isSelectAllRows,
    });
  }
}
